import DefaultAppSyncMutationAdapter from "./DefaultAppSyncMutationAdapter";
import DefaultAppSyncQueryAdapter from "./DefaultAppSyncQueryAdapter";

export default { DefaultAppSyncQueryAdapter, DefaultAppSyncMutationAdapter };
